import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'

import SearchComponent from '@cinch/oxd-components/search/src'
import { actions as reduxSearchActions } from '@cinch/oxd-redux/search/src'
import { SetSearchTerms } from '@cinch/oxd-redux/search/src/types'
import { actions as vehicleActions, selectors as vehicleSelectors } from '@cinch/oxd-redux/dealer-vehicles/src'

const { setSearchTerms } = reduxSearchActions

interface PropsFromReduxState {
  searchTerms: string
  searchIsPending: boolean
}

interface PropsFromReduxActions {
  setSearchTerms: (terms: string) => SetSearchTerms
  vehicleSearch: (terms: string) => any
}

export interface ConnnectedProps extends PropsFromReduxActions, PropsFromReduxState {}

const mapStateToProps = (state: any): PropsFromReduxState => ({
  searchTerms: state.search && state.search.searchTerms,
  searchIsPending: vehicleSelectors.getPredicate(state).searchStatus.isPending,
})

const bindDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ setSearchTerms, vehicleSearch: vehicleActions.search }, dispatch)

const GlobalSearch = connect(mapStateToProps, bindDispatchToProps)(SearchComponent)

export default GlobalSearch
